import { getApiUrl } from 'utils/api/apiHelpers'

export const FP_ENDPOINTS = {
  loads: `${getApiUrl('FMS')}/v1/shipments`,
  fleet: `${getApiUrl('FMS')}/v1/fleet`,
  statusCounts: `${getApiUrl('FMS')}/v1/shipments/status_counts`,
  motorCarriers: `${getApiUrl('FMS')}/v1/motor_carriers`,
  userMotorCarriers: `${getApiUrl('FMS')}/v1/current_user/motor_carriers`,
  userMotorCarriersJoin: `${getApiUrl('FMS')}/v1/current_user/motor_carriers/join`,
  userMotorCarriersRemove: `${getApiUrl('FMS')}/v1/current_user/motor_carriers`,
  dispatchers: `${getApiUrl('FMS')}/v1/dispatchers`,
  drivers: `${getApiUrl('FMS')}/v1/drivers`,
  equipment: `${getApiUrl('FMS')}/v1/equipment`,
  customers: `${getApiUrl('FMS')}/v1/customers`,
  trailers: `${getApiUrl('FMS')}/v1/trailers`,
  trucks: `${getApiUrl('FMS')}/v1/trucks`,
  facilities: `${getApiUrl('FMS')}/v1/facilities`,
  current_user: `${getApiUrl('FMS')}/v1/current_user`,
  motor_carriers: `${getApiUrl('FMS')}/v1/motor_carriers`,
  motor_carriers_search: `${getApiUrl('FMS')}/v1/motor_carriers/search`,
  entities: `${getApiUrl('FMS')}/v1/entities`,
  shipments: `${getApiUrl('FMS')}/v1/shipments`,
  shared_shipments: `${getApiUrl('FMS')}/v1/shared/shipments`,
  external_load_mp: `${getApiUrl('FMS')}/v1/external_shipments/marketplace`,
  subscribable_contacts: `${getApiUrl('FMS')}/v1/subscribable_contacts`,
  quickbooksAuth: `${getApiUrl('FMS')}/v1/quickbooks_oauth`,
  quickbooks: `${getApiUrl('FMS')}/v1/quickbooks`,
  marketplace_shipments: `${getApiUrl('FMS')}/v1/shipments`,
  shipmentOffers: `${getApiUrl('FMS')}/v1/offered_shipments`,
  teamMembers: `${getApiUrl('FMS')}/v1/team_members`,
  todos: `${getApiUrl('FMS')}/v1/todos`,
  motorCarrierJoinRequests: `${getApiUrl('FMS')}/v1/motor_carrier_join_requests`,
  setupGuide: `${getApiUrl('FMS')}/v1/setup_guide`,
  carrierBids: `${getApiUrl('FMS')}/v1/carrier_bids`,
  podUpload: (id: number) => `${getApiUrl('FMS')}/v1/shipments/${id}/upload_pod_documents`,
}
